<template>
  <!--公司简介-->
  <section id="profile">
    <div class="caption">
      <h2>公司简介</h2>
      <span>PROFILE</span>
    </div>
    <div class="profile">
      <video src="/profile.mp4" autoplay preload controls="controls"></video>
      <p>公司成立于2018年，注册资本1000万元，公司将景区的科技与文化相融合，为现代景区提供一站式智慧化服务，致力于做中国最顶级的先端智慧景区与文化相结合的内容及服务提供商。</p>
      <p>我们为各个景区及展馆提供专业的票务系统、大数据中心、云端服务架构搭建、沉浸式体验系统（VR、MR、全息、物体投影、体感互动、全景拍摄等）、AR智能导览系统、智慧分析系统、文创新零售体系等高端数字化内容系统。通过这些内容的融合性制作，旨在为景区带来更加智慧且便利的服务，增加游客游前、游中、游后的深度体验好感度，让旅行不仅仅停留吃、住、行、游、娱、购的单独模块化层面，而是使旅游、文化、科技真正的融合提升为一体化、人性化的体验模式，最终打造成提升人民幸福指数的城市全域旅游板块的一个核心部分。</p>
    </div>

    <div v-if="false" class="caption">
      <h2>业务方向与内容</h2>
      <span>BUSINESS</span>
    </div>
    <div v-if="false" class="business">
      <div class="grid">
        <div class="direction-1"></div>
        <div class="direction-2">
          <h1>BUSINESS DIRECTION</h1>
          <h2>业务方向</h2>
          <p>
            我们为各个景区及展馆提供专业的票务系统、大数据中心、云端服务架构搭建、沉浸式体验系统（VR、MR、全息、物体投影、体感互动、全景拍摄等）AR智能导览系统、智慧分析系统、文创新零售体系，通过这些内容的融合性制作，旨在为景区带来更加智慧且便利的服务，增加游客游前游中游后的深度体验好感度，使旅游、文化、科技真正的融合在一起并且变为一种更为人性化的体验模式，使旅行不仅仅再是吃、住、行、游、娱、购的单独模块化存在！
          </p>
        </div>
        <div class="content-1">
          <h1>BUSINESS DIRECTION</h1>
          <h2>业务内容</h2>
          <p>
            我们为各个景区及展馆提供专业的票务系统、大数据中心、云端服务架构搭建、沉浸式体验系统（VR、MR、全息、物体投影、体感互动、全景拍摄等）AR智能导览系统、智慧分析系统、文创新零售体系，通过这些内容的融合性制作，旨在为景区带来更加智慧且便利的服务，增加游客游前游中游后的深度体验好感度，使旅游、文化、科技真正的融合在一起并且变为一种更为人性化的体验模式，使旅行不仅仅再是吃、住、行、游、娱、购的单独模块化存在！
          </p>
        </div>
        <div class="content-2"></div>
      </div>
      <div class="bg">
        <div class="layer-1"></div>
        <div class="layer-2"></div>
        <div class="layer-3"></div>
      </div>
    </div>

    <div class="caption">
      <h2>联系我们</h2>
      <span>CONTACT US</span>
    </div>
    <div class="contact">
      <baidu-map id="map" :ak="mapArgs.ak" :center="mapArgs.center" :zoom="mapArgs.zoom" :scroll-wheel-zoom="true" :mapStyle="mapArgs.mapStyle">
        <bm-marker :position="mapArgs.center">
          <bm-label content="北京凯泰铭科技文化发展有限公司" :labelStyle="mapArgs.labelStyle" :offset="{width: -135, height: 30}" />
        </bm-marker>
      </baidu-map>
      <div class="card">
        <div class="text">
          <h1>北京凯泰铭科技文化发展有限公司</h1>
          <h3>地址：24H齿轮厂文创园5号楼东侧301室</h3>
          <h3>邮编：100024</h3>
          <h3>邮箱：bd@ktmtech.cn</h3>
          <h3>咨询电话：010-8578-8360</h3>
          <h2>如有问题请与我们联系！</h2>
        </div>
        <div class="wx">
          <div class="qrcode"></div>
          <span>官方微信</span>
        </div>
      </div>
    </div>

    <div class="bottom">
      <h3>做中国先端数字智慧景区与文化本身相结合的内容及服务提供商</h3>
    </div>
  </section>
</template>

<script>
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import BmMarker from "vue-baidu-map/components/overlays/Marker";
import BmLabel from "vue-baidu-map/components/overlays/Label"; //点标注

export default {
  data() {
    return {
      mapArgs: {
        ak: "9nQlAmkoFwD3zO9iE3yf4zuErCxDuZue",
        center: {
          lng: 116.55701,
          lat: 39.92326
        },
        zoom: 18,
        mapStyle: {
          styleJson: [
            {
              featureType: "land",
              elementType: "geometry",
              stylers: {
                color: "#242f3eff"
              }
            },
            {
              featureType: "manmade",
              elementType: "geometry",
              stylers: {
                color: "#242f3eff"
              }
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: {
                color: "#17263cff"
              }
            },
            {
              featureType: "road",
              elementType: "geometry.fill",
              stylers: {
                color: "#9e7d60ff"
              }
            },
            {
              featureType: "road",
              elementType: "geometry.stroke",
              stylers: {
                color: "#554631ff"
              }
            },
            {
              featureType: "districtlabel",
              elementType: "labels.text.fill",
              stylers: {
                color: "#d69563ff"
              }
            },
            {
              featureType: "districtlabel",
              elementType: "labels.text.stroke",
              stylers: {
                color: "#17263cff",
                weight: "3"
              }
            },
            {
              featureType: "poilabel",
              elementType: "labels.text.fill",
              stylers: {
                color: "#d69563ff"
              }
            },
            {
              featureType: "poilabel",
              elementType: "labels.text.stroke",
              stylers: {
                color: "#17263cff",
                weight: "3"
              }
            },
            {
              featureType: "subway",
              elementType: "geometry",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "railway",
              elementType: "geometry",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "poilabel",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "subwaylabel",
              elementType: "labels",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "subwaylabel",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "tertiarywaysign",
              elementType: "labels",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "tertiarywaysign",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "provincialwaysign",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "provincialwaysign",
              elementType: "labels",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "nationalwaysign",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "nationalwaysign",
              elementType: "labels",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "highwaysign",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "highwaysign",
              elementType: "labels",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "green",
              elementType: "geometry",
              stylers: {
                color: "#263b3eff"
              }
            },
            {
              featureType: "nationalwaysign",
              elementType: "labels.text.fill",
              stylers: {
                color: "#d0021bff"
              }
            },
            {
              featureType: "nationalwaysign",
              elementType: "labels.text.stroke",
              stylers: {
                color: "#ffffffff"
              }
            },
            {
              featureType: "city",
              elementType: "labels",
              stylers: {
                visibility: "on"
              }
            },
            {
              featureType: "city",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "city",
              elementType: "labels.text.fill",
              stylers: {
                color: "#d69563ff"
              }
            },
            {
              featureType: "city",
              elementType: "labels.text.stroke",
              stylers: {
                color: "#17263cff"
              }
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: {
                color: "#d69563ff"
              }
            },
            {
              featureType: "water",
              elementType: "labels.text.stroke",
              stylers: {
                color: "#242f3eff"
              }
            },
            {
              featureType: "local",
              elementType: "geometry.fill",
              stylers: {
                color: "#38414eff"
              }
            },
            {
              featureType: "local",
              elementType: "geometry.stroke",
              stylers: {
                color: "#ffffff00"
              }
            },
            {
              featureType: "fourlevelway",
              elementType: "geometry.fill",
              stylers: {
                color: "#38414eff"
              }
            },
            {
              featureType: "fourlevelway",
              elementType: "geometry.stroke",
              stylers: {
                color: "#ffffff00"
              }
            },
            {
              featureType: "tertiaryway",
              elementType: "geometry.fill",
              stylers: {
                color: "#38414eff"
              }
            },
            {
              featureType: "tertiaryway",
              elementType: "geometry.stroke",
              stylers: {
                color: "#ffffff00"
              }
            },
            {
              featureType: "tertiaryway",
              elementType: "labels.text.fill",
              stylers: {
                color: "#759879ff"
              }
            },
            {
              featureType: "fourlevelway",
              elementType: "labels.text.fill",
              stylers: {
                color: "#759879ff"
              }
            },
            {
              featureType: "highway",
              elementType: "labels.text.fill",
              stylers: {
                color: "#759879ff"
              }
            },
            {
              featureType: "highway",
              elementType: "geometry.fill",
              stylers: {
                color: "#9e7d60ff"
              }
            },
            {
              featureType: "highway",
              elementType: "geometry.stroke",
              stylers: {
                color: "#554631ff"
              }
            },
            {
              featureType: "provincialway",
              elementType: "geometry.fill",
              stylers: {
                color: "#9e7d60ff"
              }
            },
            {
              featureType: "provincialway",
              elementType: "geometry.stroke",
              stylers: {
                color: "#554631ff"
              }
            },
            {
              featureType: "tertiaryway",
              elementType: "labels.text.stroke",
              stylers: {
                color: "#1a2e1cff"
              }
            },
            {
              featureType: "fourlevelway",
              elementType: "labels.text.stroke",
              stylers: {
                color: "#1a2e1cff"
              }
            },
            {
              featureType: "highway",
              elementType: "labels.text.stroke",
              stylers: {
                color: "#1a2e1cff"
              }
            },
            {
              featureType: "nationalway",
              elementType: "labels.text.stroke",
              stylers: {
                color: "#1a2e1cff"
              }
            },
            {
              featureType: "nationalway",
              elementType: "labels.text.fill",
              stylers: {
                color: "#759879ff"
              }
            },
            {
              featureType: "nationalway",
              elementType: "geometry.fill",
              stylers: {
                color: "#9e7d60ff"
              }
            },
            {
              featureType: "nationalway",
              elementType: "geometry.stroke",
              stylers: {
                color: "#554631ff"
              }
            },
            {
              featureType: "cityhighway",
              elementType: "geometry.fill",
              stylers: {
                color: "#9e7d60ff"
              }
            },
            {
              featureType: "cityhighway",
              elementType: "geometry.stroke",
              stylers: {
                color: "#554631ff"
              }
            },
            {
              featureType: "arterial",
              elementType: "geometry.fill",
              stylers: {
                color: "#9e7d60ff"
              }
            },
            {
              featureType: "arterial",
              elementType: "geometry.stroke",
              stylers: {
                color: "#554631fa"
              }
            },
            {
              featureType: "medicallabel",
              elementType: "labels",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "medicallabel",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "entertainmentlabel",
              elementType: "labels",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "entertainmentlabel",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "estatelabel",
              elementType: "labels",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "estatelabel",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "businesstowerlabel",
              elementType: "labels",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "businesstowerlabel",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "companylabel",
              elementType: "labels",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "companylabel",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "governmentlabel",
              elementType: "labels",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "governmentlabel",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "restaurantlabel",
              elementType: "labels",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "restaurantlabel",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "hotellabel",
              elementType: "labels",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "hotellabel",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "shoppinglabel",
              elementType: "labels",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "shoppinglabel",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "lifeservicelabel",
              elementType: "labels",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "lifeservicelabel",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "carservicelabel",
              elementType: "labels",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "carservicelabel",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "financelabel",
              elementType: "labels",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "financelabel",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "otherlabel",
              elementType: "labels",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "otherlabel",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "airportlabel",
              elementType: "labels",
              stylers: {
                visibility: "on"
              }
            },
            {
              featureType: "airportlabel",
              elementType: "labels.text.fill",
              stylers: {
                color: "#d69563ff"
              }
            },
            {
              featureType: "airportlabel",
              elementType: "labels.text.stroke",
              stylers: {
                color: "#17263cff"
              }
            },
            {
              featureType: "airportlabel",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "highway",
              stylers: {
                level: "6",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "highway",
              stylers: {
                level: "7",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "highway",
              stylers: {
                level: "8",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "highway",
              stylers: {
                level: "9",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "highway",
              stylers: {
                level: "10",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "highway",
              elementType: "geometry",
              stylers: {
                visibility: "off",
                level: "6",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "highway",
              elementType: "geometry",
              stylers: {
                visibility: "off",
                level: "7",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "highway",
              elementType: "geometry",
              stylers: {
                visibility: "off",
                level: "8",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "highway",
              elementType: "geometry",
              stylers: {
                visibility: "off",
                level: "9",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "highway",
              elementType: "geometry",
              stylers: {
                visibility: "off",
                level: "10",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "nationalway",
              stylers: {
                level: "6",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "nationalway",
              stylers: {
                level: "7",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "nationalway",
              stylers: {
                level: "8",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "nationalway",
              stylers: {
                level: "9",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "nationalway",
              stylers: {
                level: "10",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "nationalway",
              elementType: "geometry",
              stylers: {
                visibility: "off",
                level: "6",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "nationalway",
              elementType: "geometry",
              stylers: {
                visibility: "off",
                level: "7",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "nationalway",
              elementType: "geometry",
              stylers: {
                visibility: "off",
                level: "8",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "nationalway",
              elementType: "geometry",
              stylers: {
                visibility: "off",
                level: "9",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "nationalway",
              elementType: "geometry",
              stylers: {
                visibility: "off",
                level: "10",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "nationalway",
              elementType: "labels",
              stylers: {
                visibility: "off",
                level: "6",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "nationalway",
              elementType: "labels",
              stylers: {
                visibility: "off",
                level: "7",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "nationalway",
              elementType: "labels",
              stylers: {
                visibility: "off",
                level: "8",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "nationalway",
              elementType: "labels",
              stylers: {
                visibility: "off",
                level: "9",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "nationalway",
              elementType: "labels",
              stylers: {
                visibility: "off",
                level: "10",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "highway",
              elementType: "labels",
              stylers: {
                visibility: "off",
                level: "6",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "highway",
              elementType: "labels",
              stylers: {
                visibility: "off",
                level: "7",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "highway",
              elementType: "labels",
              stylers: {
                visibility: "off",
                level: "8",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "highway",
              elementType: "labels",
              stylers: {
                visibility: "off",
                level: "9",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "highway",
              elementType: "labels",
              stylers: {
                visibility: "off",
                level: "10",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "provincialway",
              stylers: {
                level: "8",
                curZoomRegionId: "0",
                curZoomRegion: "8-9"
              }
            },
            {
              featureType: "provincialway",
              stylers: {
                level: "9",
                curZoomRegionId: "0",
                curZoomRegion: "8-9"
              }
            },
            {
              featureType: "provincialway",
              elementType: "geometry",
              stylers: {
                visibility: "off",
                level: "8",
                curZoomRegionId: "0",
                curZoomRegion: "8-9"
              }
            },
            {
              featureType: "provincialway",
              elementType: "geometry",
              stylers: {
                visibility: "off",
                level: "9",
                curZoomRegionId: "0",
                curZoomRegion: "8-9"
              }
            },
            {
              featureType: "provincialway",
              elementType: "labels",
              stylers: {
                visibility: "off",
                level: "8",
                curZoomRegionId: "0",
                curZoomRegion: "8-9"
              }
            },
            {
              featureType: "provincialway",
              elementType: "labels",
              stylers: {
                visibility: "off",
                level: "9",
                curZoomRegionId: "0",
                curZoomRegion: "8-9"
              }
            },
            {
              featureType: "cityhighway",
              stylers: {
                level: "6",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "cityhighway",
              stylers: {
                level: "7",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "cityhighway",
              stylers: {
                level: "8",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "cityhighway",
              stylers: {
                level: "9",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "cityhighway",
              stylers: {
                level: "10",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "cityhighway",
              elementType: "geometry",
              stylers: {
                visibility: "off",
                level: "6",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "cityhighway",
              elementType: "geometry",
              stylers: {
                visibility: "off",
                level: "7",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "cityhighway",
              elementType: "geometry",
              stylers: {
                visibility: "off",
                level: "8",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "cityhighway",
              elementType: "geometry",
              stylers: {
                visibility: "off",
                level: "9",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "cityhighway",
              elementType: "geometry",
              stylers: {
                visibility: "off",
                level: "10",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "cityhighway",
              elementType: "labels",
              stylers: {
                visibility: "off",
                level: "6",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "cityhighway",
              elementType: "labels",
              stylers: {
                visibility: "off",
                level: "7",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "cityhighway",
              elementType: "labels",
              stylers: {
                visibility: "off",
                level: "8",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "cityhighway",
              elementType: "labels",
              stylers: {
                visibility: "off",
                level: "9",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "cityhighway",
              elementType: "labels",
              stylers: {
                visibility: "off",
                level: "10",
                curZoomRegionId: "0",
                curZoomRegion: "6-10"
              }
            },
            {
              featureType: "arterial",
              stylers: {
                level: "9",
                curZoomRegionId: "0",
                curZoomRegion: "9-10"
              }
            },
            {
              featureType: "arterial",
              stylers: {
                level: "10",
                curZoomRegionId: "0",
                curZoomRegion: "9-10"
              }
            },
            {
              featureType: "arterial",
              elementType: "geometry",
              stylers: {
                visibility: "off",
                level: "9",
                curZoomRegionId: "0",
                curZoomRegion: "9-10"
              }
            },
            {
              featureType: "arterial",
              elementType: "geometry",
              stylers: {
                visibility: "off",
                level: "10",
                curZoomRegionId: "0",
                curZoomRegion: "9-10"
              }
            },
            {
              featureType: "arterial",
              elementType: "labels",
              stylers: {
                visibility: "off",
                level: "9",
                curZoomRegionId: "0",
                curZoomRegion: "9-10"
              }
            },
            {
              featureType: "arterial",
              elementType: "labels",
              stylers: {
                visibility: "off",
                level: "10",
                curZoomRegionId: "0",
                curZoomRegion: "9-10"
              }
            },
            {
              featureType: "building",
              elementType: "geometry.fill",
              stylers: {
                color: "#2a3341ff"
              }
            },
            {
              featureType: "building",
              elementType: "geometry.stroke",
              stylers: {
                color: "#1a212eff"
              }
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: {
                color: "#759879ff"
              }
            },
            {
              featureType: "road",
              elementType: "labels.text.stroke",
              stylers: {
                color: "#1a2e1cff"
              }
            },
            {
              featureType: "provincialway",
              elementType: "labels.text.fill",
              stylers: {
                color: "#759879ff"
              }
            },
            {
              featureType: "cityhighway",
              elementType: "labels.text.fill",
              stylers: {
                color: "#759879ff"
              }
            },
            {
              featureType: "arterial",
              elementType: "labels.text.fill",
              stylers: {
                color: "#759879ff"
              }
            },
            {
              featureType: "provincialway",
              elementType: "labels.text.stroke",
              stylers: {
                color: "#1a2e1cff"
              }
            },
            {
              featureType: "cityhighway",
              elementType: "labels.text.stroke",
              stylers: {
                color: "#1a2e1cff"
              }
            },
            {
              featureType: "arterial",
              elementType: "labels.text.stroke",
              stylers: {
                color: "#1a2e1cff"
              }
            },
            {
              featureType: "local",
              elementType: "labels",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "manmade",
              elementType: "labels.text.fill",
              stylers: {
                color: "#d69563ff"
              }
            },
            {
              featureType: "manmade",
              elementType: "labels.text.stroke",
              stylers: {
                color: "#17263cff"
              }
            },
            {
              featureType: "subwaystation",
              elementType: "geometry",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "transportationlabel",
              elementType: "labels.icon",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "transportationlabel",
              elementType: "labels",
              stylers: {
                visibility: "off"
              }
            },
            {
              featureType: "estate",
              elementType: "geometry",
              stylers: {
                color: "#2a3341ff"
              }
            }
          ]
        },
        labelStyle: {
          color: "#9d828c",
          fontSize: "20px",
          backgroundColor: "#232f3d",
          borderColor: "#c09b80"
        }
      }
    };
  },
  methods: {
    // mapReady({ BMap, map }) {}
  },
  mounted() {},
  components: {
    BaiduMap,
    BmMarker,
    BmLabel
  }
};
</script>

<style lang="scss" scoped>
.caption {
  // width: 40%;
  padding-bottom: 30px;
  text-align: center;

  > h1 {
    margin-bottom: 5px;
    font-weight: 500;
    font-size: 22px;
    text-align: center;
    color: #333333;
  }
}

section {
  /* 简介 */
  &#profile {
    width: 100%;

    > .profile {
      padding-left: 10%;
      padding-right: 10%;
      padding-bottom: 30px;
      text-align: center;

      > video {
        width: 100%;
        height: percentage(1080/1920);
        padding-bottom: 30px;
      }

      > p {
        text-align: justify;
        text-indent: 0.16rem;
      }
    }

    /* 简介 - 业务方向与内容 */
    > .business {
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow: hidden;
      margin-bottom: 30px;
      position: relative;

      > .bg {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 100%;
        position: absolute;
        bottom: 0;
        z-index: -1;

        > .layer-1 {
          flex-grow: 15;
        }

        > .layer-2 {
          align-self: flex-end;
          background-color: #145a84;
          width: 50vw;
          flex-grow: 24;
        }

        > .layer-3 {
          background-color: #145a84;
          width: 100%;
          flex-grow: 61;
        }
      }

      > .grid {
        display: grid;
        grid-template-rows: 1fr 1fr;
        grid-template-columns: 1fr 1fr;
        width: 60vw;

        > .direction-1 {
          background: url(../../assets/images/aboutus/direction.png) no-repeat
            center;
          background-size: cover;
        }

        > .direction-2 {
          padding: 10%;
          background-color: #ffffff;
          // text-indent: 32px;

          > h1,
          > h2 {
            text-indent: 0;
            // text-align: center;
            font-size: 0.1rem;
          }

          > p {
            margin-top: 10px;
            text-align: justify;
          }
        }

        > .content-1 {
          padding: 10%;
          background-color: #145a84;
          color: #ffffff;
          // text-indent: 32px;

          > h1,
          > h2 {
            text-indent: 0;
            // text-align: center;
            font-size: 0.1rem;
          }

          > p {
            margin-top: 10px;
            text-align: justify;
          }
        }

        > .content-2 {
          background: url(../../assets/images/aboutus/content.png) no-repeat
            center;
          background-size: cover;
        }
      }

      // >.grid ::after {
      //   content: "";
      //   display: block;
      //   // padding: 70%; // 这里的padding = height / width
      // }
    }

    /* 简介 - 联系我们 */
    > .contact {
      display: flex;

      > #map {
        width: 70vw;
        height: 70vh;
        border: #ccc solid 1px;
        font-size: 12px;
      }

      > .card {
        display: flex;
        flex-direction: row;
        position: relative;
        width: 41vw;
        height: 33vh;
        top: 21vh;
        left: -19.5vw;
        background-color: #ffffff;
        border-radius: 0.03rem;
        box-shadow: 0 2px 15px 0 rgba(80, 80, 80, 0.15);
        padding: 2vw;

        > .text {
          flex-grow: 1;

          > h1 {
            margin-bottom: 15px;
            font-size: 1.3vw;
            font-weight: bold;
          }

          > h2 {
            margin-top: 10%;
            // font-size: 14px;
            font-size: 1.2vw;
            font-weight: bold;
          }

          > h3 {
            margin: 6px 0;
            // font-size: 12px;
            font-size: 1vw;
            font-weight: normal;
          }
        }

        > .wx {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: 15px;

          .qrcode {
            background: url(../../assets/images/aboutus/qrcode.png) no-repeat
              center;
            background-size: contain;
            width: 10vw;
            height: 10vw;
          }

          span {
            margin-top: 1vh;
            color: #888888;
          }
        }
      }
    }

    > .bottom {
      width: 100%;
      background: url(../../assets/images/aboutus/bg.png);
      height: 1.5rem;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;

      > h3 {
        margin-right: 10px;
        letter-spacing: 10px;
      }
    }

    &:parent {
      background-color: black;
    }
  }
}
</style>